/* projects/speaker-platform/src/app/organisms/admin/speaker-edit-categories/speaker-edit-categories.component.scss */
/*# sourceMappingURL=speaker-edit-categories.component-CVD4LRSQ.css.map */
